import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=a8a7cf8a&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=ts"
export * from "./MenuItem.vue?vue&type=script&lang=ts"
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=a8a7cf8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a7cf8a",
  null
  
)

export default component.exports